import { FC, Fragment } from 'react';
import { styled } from '@mui/material';
import { Avatar as BaseAvatar, Box, Chip as BaseChip, ChipProps } from '@mui/material';

const Avatar = styled(BaseAvatar)(({ theme }) => ({
    '&': {
        backgroundColor: theme.palette.action.selected,
        minWidth: 24,
        height: 24,
    },
    '&.MuiChip-deleteIcon': {
        color: theme.palette.text.primary,
        fontSize: theme.typography.caption.fontSize,
    },
}));

const Chip = styled(BaseChip)(({ theme }) => ({
    '& .MuiChip-deleteIcon': {
        color: theme.palette.text.primary,
        fontSize: theme.typography.caption.fontSize,
    },
}));

type CountChipProps = {
    label: React.ReactNode;
    count?: number;
    hideCount?: boolean;
    hideZeroCount?: boolean;
} & ChipProps;

const CountChip: FC<CountChipProps> = ({ label, count, hideCount, hideZeroCount, ...props }) => {
    return (
        <Chip
            variant="outlined"
            {...props}
            label={label}
            deleteIcon={hideCount || hideZeroCount ? <Box /> : <Avatar>{count}</Avatar>}
            onDelete={() => {}}
        />
    );
};

interface CountChipsProps {
    items: CountChipProps[];
}

const CountChips: FC<CountChipsProps> = ({ items }) => {
    return (
        <Fragment>
            {items.map((item: CountChipProps, index: number) => {
                return <CountChip key={index} {...item} />;
            })}
        </Fragment>
    );
};

export type { CountChipProps };
export default CountChip;

export type { CountChipsProps };
export { CountChips };
